import { createTheme } from '@mui/material/styles'
import type { } from '@mui/x-data-grid/themeAugmentation';

declare module '@mui/material/styles' {
    interface Theme {
        status: {
            danger: string;
        };
    }
    // allow configuration using `createTheme`
    interface ThemeOptions {
        status?: {
            danger?: string;
        };
    }
}

const theme = createTheme({
    palette: {
        background: { default: '#EFEEEF' },
        primary: { light: '#518fd5', main: '#0062A3', dark: '#003974', contrastText: '#fff' },
        secondary: { light: '#66e0ff', main: '#00AEEF', dark: '#007fbc', contrastText: '#000' }
    },
    status: {
        danger: '#ba000d'
    },
    typography: {
        h1: { fontFamily: "Roboto", fontWeight: 300, fontSize: "6rem", lineHeight: 1.167, letterSpacing: "-0.01562em" },
        h2: { fontFamily: "Roboto", fontWeight: 300, fontSize: "3.75rem", lineHeight: 1.2, letterSpacing: "-0.00833em" },
        h3: { fontFamily: "Roboto", fontWeight: 400, fontSize: "3rem", lineHeight: 1.167, letterSpacing: "0em" },
        h4: { fontFamily: "Roboto", fontWeight: 400, fontSize: "2.125rem", lineHeight: 1.235, letterSpacing: "0.00735em" },
        h5: { fontFamily: "Roboto", fontWeight: 400, fontSize: "1.5rem", lineHeight: 1.334, letterSpacing: "0em" },
        h6: { fontFamily: "Roboto", fontWeight: 500, fontSize: "1.25rem", lineHeight: 1.6, letterSpacing: "0.0075em" },
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: 'white',
                },
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ECECEC',
                },
            }
        }
    }
});

export default theme;